import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Renderer2, HostListener } from "@angular/core";
import { FormControl } from '@angular/forms';
import { merge } from 'rxjs';
import { StorageService } from "@app/services/storage/storage.service";
import { Router } from "@angular/router";
import { ApplicationService } from "@app/services/application/application.service";
import { ApiService } from "@app/gateway/services/api.service";
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { ModalService } from '@app/services/modal/modal.service';
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { TokenService } from "@app/services/token/token.service";
import { HttpHeaders } from "@angular/common/http";
import { LargeDataComponent } from "@app/components/largeDataComponent/large-data.component";
import { MatDialog } from '@angular/material/dialog';
import { ServiceConfigService } from "@app/services/service-config.service";
declare let gtag: Function;

@Component({
  selector: "nh-memberAssistance-dashboard",
  templateUrl: "./memberAssistanceDashboard.component.html",
  styleUrls: ["./memberAssistanceDashboard.component.scss"],
  standalone: false
})

export class MemberAssistanceDashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('datatableWrapper', { static: false }) wrapperRef!: ElementRef<HTMLDivElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  totalResults = [];
  exportData = []
  openDialogue = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>(this.totalResults)
  activeTab: string = 'all';
  today: any = new Date();
  pageSize = 7;
  currentPage = 1;
  currentPageMat = 1;
  currentData = []
  columnsSet1 = [
    { name: 'Member Name', prop: 'memberName' },
    { name: 'Case Number', prop: 'caseNumber' }
  ];
  columnsSet2 = [
    { name: 'Due Date', prop: 'dueDate' },
    { name: 'Address', prop: 'address' }
  ];
  actionToolTip = "Click the link below to complete the actions for the member. The ‘View TennCare Connect’ hyperlink will display for members not currently pending another action.";
  caseStatusTooTip = "The Case Status column is updated daily.";
  lastActionToolTip = "After you complete an action, the Last Action date will update when you refresh the page.";
  latestNoticeToolTip = "When a date is listed, you can click the hyperlink to view the latest notice in My Letters.\nIn Progress means that the latest notice is not yet available in My Letters. Check again in 2-3 business days.";
  total = 1;
  paginatedData = [];
  pages: number[] = [];
  visiblePagesLength = 7;
  lastUpdatedDate;
  sortOptions: string[] = [
    'Due Date - New to Old',
    'Due Date - Old to New',
    'Latest Notice - New to Old',
    'Latest Notice - Old to New'
  ];
  selectedSort: string | null = null;
  originalResults: any[] = [];

  // Filter FormControls
  filterActionAI = new FormControl(false);   // Upload Documents
  filterActionPR = new FormControl(false);   // Complete Renewal
  filterActionPT = new FormControl(false);   // Complete Questions for Review
  filterActionTC = new FormControl(false);   // View TennCare Connect
  filterStatusApproved = new FormControl(false);
  filterStatusPending = new FormControl(false);
  filterStatusTerminated = new FormControl(false);
  entityId = this.apiService.getEntityId()
  encodedEntityId = encodeURIComponent(this.entityId);
  ltssDashboardSwitch: boolean;
  mobile = window.innerWidth < 768;
  sortFilterOpenUp = false;


  constructor(
    private renderer: Renderer2,
    protected storageService: StorageService,
    private router: Router,
    protected application: ApplicationService,
    public apiService: ApiService,
    private datePipe: DatePipe,
    private modal: ModalService,
    private token: TokenService,
    private dialog: MatDialog,
    private readonly serviceConfigService: ServiceConfigService,
  ) {
  }

  get totalPages(): number {
    return Math.ceil(this.currentData.length / this.pageSize);
  }

  get paginatedRows() {
    this.currentData = this.totalResults
    const startIdx = (this.currentPage - 1) * this.pageSize;
    return this.currentData.slice(startIdx, startIdx + this.pageSize);
  }

  openLargeData(data, $event: MouseEvent): void {
    const rect = ($event.target as HTMLElement).getBoundingClientRect();
    this.dialog.open(LargeDataComponent, {
      data,
      width: '400px',
      position: {
        top: rect.bottom + 'px', // Below the cell
        left: rect.left + 'px'   // Align left edges
      },
      autoFocus: false,
      restoreFocus: false,
      ariaLabel: 'Last Notice Special Notes'
    });
    this.openDialogue = true
  }

  getFullName(res) {
    if (res) {
      let fullName;
      const middleName = res.middleName
      if (middleName) {
        fullName = res.firstName + ' ' + res.middleName + ' ' + res.lastName;
      } else {
        fullName = res.firstName + ' ' + res.lastName;
      }
      return fullName
    }
  }

  getMemberAssistanceData(tempArray) {
    let dataArray = [];
    // const earliestDateInvs = Object.values(
    //   tempArray.reduce((acc, current) => {
    //     const id = current.clientId;
    //     if (!acc[id]) {
    //       acc[id] = current;
    //     } else {
    //       const existingDate = new Date(acc[id].vclDueDt);
    //       const newDueDate = new Date(current.vclDueDt);
    //       if (newDueDate < existingDate) {
    //         acc[id] = current
    //       }
    //     }
    //     return acc;
    //   }, {} as Record<string, any>)
    // )

    // for (const key in earliestDateInvs) {
    //   const earliestItems = []
    //   earliestItems.push(earliestDateInvs[key])
    // }
    // tempArray = earliestDateInvs
    const getLastUpdateDateObj = tempArray.find(m => m.effectiveBeginDate)
    this.lastUpdatedDate = getLastUpdateDateObj?.effectiveBeginDate
    dataArray = tempArray.map(user => ({
      ...(this.ltssDashboardSwitch ? { showDot: user.actionChangeInd === 'Y' } : {}),
      memberName: this.getFullName(user) + "<br><strong>DOB: </strong>" + user.dob,
      caseNumber: user.caseNumber,
      caseStatus: user.caseStatus ? user.caseStatus === 'AP' ? 'Approved' : user.caseStatus === 'PE' ? 'Pending' : user.caseStatus === 'TN' ? 'Terminated' : user.caseStatus === 'DN' ? 'Denied' : '' : '',
      action: user.actionCd,
      ...(this.ltssDashboardSwitch ? { latestNotice: (user.latestNoticeDt !== null) ? user.latestNoticeDt : (user.latestNoticeDt === null && user.actionCd !== 'TC') ? 'In Progress' : '' } : {}),
      lastAction: user.lastActionDate,
      remove: true,
      dueDate: user.dueDt,
      indivId: user.clientId,
      age: user.clientAge,
      activityType: user.activityType,
      renewalDate: user.renewalDt,
      countyCode: user.countyCode,
      countyName: user.countyDesc,
      coeCode: user.coeCode,
      coeDescription: user.coeDescription,
      status: user.cgStatusCd ? user.cgStatusCd === 'AP' ? 'Approved' : user.cgStatusCd === 'PE' ? 'Pending' : user.cgStatusCd === 'TN' ? 'Terminated' : user.cgStatusCd === 'DN' ? 'Denied' : '' : '',
      mcoName: user.mcoName,
      homePhoneNumber: user.homePhoneNumber,
      cellPhoneNumber: user.cellPhoneNumber,
      workPhoneNumber: user.workPhoneNumber,
      aiRequestDate: user.aiRequestDate,
      aiDueDate: user.vclDueDt,
      aiRequested: user.aiRequested,
      lastNoticeSpecialNotes: user.lastNoticeSpecialNotes,
      levelOfCare: user.levelOfCare,
      levelOfCareDate: user.levelOfCareDate
    }))
    return dataArray
  }

  private prioritizeShowDot(items: any[]): any[] {
    return [...items].sort((first, second) => Number(second.showDot === true) - Number(first.showDot === true));
  }

  // getDueDate(user) {
  //   if (user.actionCd === 'PT') {
  //     return user.vclDueDt
  //   } else if (user.actionCd === 'AI') {
  //     return user.vclDueDt
  //   } else if (user.actionCd === 'PR') {
  //     return user.renewalDt
  //   } else if (user.actionCd === 'TC') {
  //     return ''
  //   }
  // }


  loadData() {
    this.total = Math.ceil(this.totalResults.length / this.pageSize);
    this.pages = Array.from({ length: this.total }, (_, i) => i + 1);
    this.updatePageWindow();
    this.updatePagination();
  }

  onSortChange(sortType: string) {
    // Toggle off if same sort clicked again
    this.selectedSort = this.selectedSort === sortType ? null : sortType;
    gtag('event', 'sortChange', {
      'event_category': 'Member Assistance Dashboard',
      'event_label': 'Changed sort',
      'value': sortType,
    });
    this.applyFiltersAndSort();
  }

  toggleCheckbox(control: FormControl): void {
    control.setValue(!control.value);
  }

  clearFilters(): void {
    this.filterActionAI.setValue(false);
    this.filterActionPR.setValue(false);
    this.filterActionPT.setValue(false);
    this.filterActionTC.setValue(false);
    this.filterStatusApproved.setValue(false);
    this.filterStatusPending.setValue(false);
    this.filterStatusTerminated.setValue(false);
  }

  applyFiltersAndSort() {
    let filtered = [...this.originalResults];

    // Action Needed filter
    const activeActions: string[] = [];
    if (this.filterActionAI.value === true) activeActions.push('AI');
    if (this.filterActionPR.value === true) activeActions.push('PR');
    if (this.filterActionPT.value === true) activeActions.push('PT');
    if (this.filterActionTC.value === true) activeActions.push('TC');
    if (activeActions.length > 0) {
      filtered = filtered.filter(r => activeActions.includes(r.action));
      gtag('event', 'filterActionNeeded', {
        'event_category': 'Member Assistance Dashboard',
        'event_label': 'Action Needed filter',
        'value': activeActions.join(','),
      });
    }

    // Case Status filter
    const activeStatuses: string[] = [];
    if (this.filterStatusApproved.value === true) activeStatuses.push('Approved');
    if (this.filterStatusPending.value === true) activeStatuses.push('Pending');
    if (this.filterStatusTerminated.value === true) activeStatuses.push('Terminated');
    if (activeStatuses.length > 0) {
      filtered = filtered.filter(r => activeStatuses.includes(r.caseStatus));
      gtag('event', 'filterCaseStatus', {
        'event_category': 'Member Assistance Dashboard',
        'event_label': 'Case Status filter',
        'value': activeStatuses.join(','),
      });
    }

    this.totalResults = this.prioritizeShowDot(filtered);

    if (this.selectedSort) {
      switch (this.selectedSort) {
        case 'Due Date - New to Old': this.sortByDateField('dueDate', 'desc'); break;
        case 'Due Date - Old to New': this.sortByDateField('dueDate', 'asc'); break;
        case 'Latest Notice - New to Old': this.sortByDateField('latestNotice', 'desc'); break;
        case 'Latest Notice - Old to New': this.sortByDateField('latestNotice', 'asc'); break;
      }
    } else {
      this.currentPageMat = 1;
      this.loadData();
    }
    this.refreshSortFilterDirectionAfterRender();
  }

  private refreshSortFilterDirectionAfterRender(): void {
    const toggle = document.getElementById('sortFilterDropdown') as HTMLElement | null;
    const menu = document.querySelector('#sortFilterDropdown + .sort-filter-menu') as HTMLElement | null;

    if (!toggle || !menu) {
      return;
    }

    const isOpen = toggle.getAttribute('aria-expanded') === 'true' || menu.classList.contains('show');

    if (!isOpen) {
      this.setSortFilterDirection();
      return;
    }

    setTimeout(() => {
      this.setSortFilterDirection();
      const dropdownApi = (window as any)?.bootstrap?.Dropdown;
      const instance = dropdownApi?.getOrCreateInstance?.(toggle);
      instance?.update?.();
    }, 0);
  }

  private sortByDateField(field: 'dueDate' | 'latestNotice', direction: 'asc' | 'desc') {
    const inProgressAsMax = field === 'latestNotice';
    this.totalResults.sort((a, b) => {
      const firstDate = this.parseDateValue(a?.[field], inProgressAsMax);
      const secondDate = this.parseDateValue(b?.[field], inProgressAsMax);
      if (firstDate === null && secondDate === null) return 0;
      if (firstDate === null) return 1;
      if (secondDate === null) return -1;
      const compare = firstDate - secondDate;
      return direction === 'asc' ? compare : -compare;
    });
    this.currentPageMat = 1;
    this.loadData();
  }

  private parseDateValue(value: any, inProgressAsMax = false): number | null {
    if (!value) return null;
    if (typeof value === 'string' && value.trim().toLowerCase() === 'in progress') {
      return inProgressAsMax ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
    }
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  updatePagination() {
    const start = (this.currentPageMat - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedData = this.totalResults.slice(start, end);
    this.dataSource = new MatTableDataSource<any>(this.paginatedData)
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.total) {
      this.currentPageMat = page;
      this.updatePageWindow();
      this.updatePagination();
    }
  }

  updatePageWindow(): void {
    this.pages = [];
    let start = this.currentPage;
    if (start + this.visiblePagesLength - 1 > this.total) {
      start = Math.max(1, this.total - this.visiblePagesLength + 1);
    }

    for (let i = 0; i < this.visiblePagesLength; i++) {
      const page = start + i;
      if (page <= this.total) {
        this.pages.push(page);
      }
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  uploadProof() {
    console.log('print')
  }

  jsonToCsv(json) {

    const sessions = json;
    if (!sessions.length) {
      return 'No sessions to export'
    }

    const rows = sessions.map(session => ({
      caseNum: session.caseNumber,
      firstName: session.firstName,
      middleName: session.middleName,
      lastName: session.lastName,
      clientId: session.clientId,
      DOB: session.dob,
      ClientAge: session.clientAge,
      ActivityType: session.activityType,
      RenewalDate: session.renewalDt,
      CountyCode: session.coeCode,
      CountyName: session.countyDesc,
      COECode: session.countyCode,
      Status: session.cgStatusCd,
      COEDescription: session.coeDescription,
      MCOName: session.mcoName,
      HomePhoneNumber: session.homePhoneNumber,
      CellPhoneNumber: session.cellPhoneNumber,
      WorkPhoneNumber: session.workPhoneNumber,
      AIRequestDate: session.aiRequestDate,
      AIDueDate: session.vclDueDt,
      AIRequested: session.aiRequested,
      LastNoticeSpecialNotes: session.lastNoticeSpecialNotes,
      LevelOfCare: session.levelOfCare,
      LevelOfCareDate: session.levelOfCareDate,
      ...(this.ltssDashboardSwitch ? { LatestNotice: (session.latestNoticeDt !== null) ? session.latestNoticeDt : (session.latestNoticeDt === null && session.actionCd !== 'TC') ? 'In Progress' : '' } : {})
    }));

    const headers = [{ label: 'Case Number', key: 'caseNum' }, { label: 'First Name', key: 'firstName' }, { label: 'Middle Initial', key: 'middleName' }, { label: 'Last Name', key: 'lastName' }, { label: 'Client ID', key: 'clientId' },
    { label: 'DOB', key: 'DOB' }, { label: 'Client Age', key: 'ClientAge' }, { label: 'Activity Type', key: 'ActivityType' }, { label: 'Renewal Date', key: 'RenewalDate' },
    { label: 'County Code', key: 'CountyCode' }, { label: 'County Name', key: 'CountyName' }, { label: 'COE Code', key: 'COECode' }, { label: 'Status', key: 'Status' }, { label: 'COE Description', key: 'COEDescription' }, { label: 'MCO Name', key: 'MCOName' }, { label: 'Home Phone Number', key: 'HomePhoneNumber' },
    { label: 'Cell Phone Number', key: 'CellPhoneNumber' }, { label: 'Work Phone Number', key: 'WorkPhoneNumber' }, { label: 'AI Request Date', key: 'AIRequestDate' }, { label: 'AI Due Date', key: 'AIDueDate' }, { label: 'AI Requested', key: 'AIRequested' }, { label: 'Last Notice Special Notes', key: 'LastNoticeSpecialNotes' },
    { label: 'Level Of Care', key: 'LevelOfCare' }, { label: 'Level of Care Date', key: 'LevelOfCareDate' },
    ...(this.ltssDashboardSwitch ? [{ label: 'Latest Notice', key: 'LatestNotice' }] : [])];


    const csvRows = [headers.map(h => `"${h.label}"`).join(','),
    ...rows.map(row =>
      headers.map(h => `"${row[h.key] ?? ''}"`).join(',')
    )]

    const exportDate = `Date of Export: ${this.formatDateUS(new Date())}`;
    return [exportDate, ...csvRows].join('\r\n');

  }

  formatDateUS(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${mm}/${dd}/${yyyy} ${hh}:${min}:${ss}`;
  }


  exportExcel(): void {
    const selectedData = this.exportData
    const csv = this.jsonToCsv(selectedData)

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    saveAs(blob, 'MyMemberAssistanceDashboard_' + this.datePipe.transform(this.today, 'MM-dd-yyy') + '.csv')
  }


  ngOnInit() {
    this.updateMobileMode();
    this.ltssDashboardSwitch = this.serviceConfigService.getServerConfig().ltssDashboardSwitch;
    const postObj = {
      "indvNums": JSON.parse(sessionStorage.getItem('indivIdList'))
    }
    this.application.viewDashboard(postObj, 'TCVAD').subscribe((res: any) => {
        this.exportData = res;
        if (this.ltssDashboardSwitch) {
          this.originalResults = this.prioritizeShowDot(this.getMemberAssistanceData(res));
          this.totalResults = [...this.originalResults];

          // Subscribe to filter control changes
          merge(
            this.filterActionAI.valueChanges,
            this.filterActionPR.valueChanges,
            this.filterActionPT.valueChanges,
            this.filterActionTC.valueChanges,
            this.filterStatusApproved.valueChanges,
            this.filterStatusPending.valueChanges,
            this.filterStatusTerminated.valueChanges
          ).subscribe(() => this.applyFiltersAndSort());

          const allColumns = Object.keys(this.totalResults[0]);
          // Ensure 'remove' column is at the end for stickyEnd to work properly
          this.displayedColumns = ['showDot'].concat(allColumns.filter(col => col !== 'showDot' && col !== 'remove')).concat(['remove']);
        } else {
          this.totalResults = this.getMemberAssistanceData(res);
          const allColumns = Object.keys(this.totalResults[0]);
          // Ensure 'remove' column is at the end for stickyEnd to work properly
          this.displayedColumns = allColumns.filter(col => col !== 'remove').concat(['remove']);
        }

        this.dataSource.paginator = this.paginator
        this.loadData();
      })
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateMobileMode();
    this.setSortFilterDirection();
  }

  setSortFilterDirection(): void {
    const toggle = document.getElementById('sortFilterDropdown') as HTMLElement | null;
    const menu = document.querySelector('#sortFilterDropdown + .sort-filter-menu') as HTMLElement | null;
    if (!toggle || !menu) {
      return;
    }

    const viewportPadding = 12;
    const requiredMenuHeight = this.getSortFilterMenuHeight(menu);
    const spaceBelow = window.innerHeight - toggle.getBoundingClientRect().bottom - viewportPadding;

    // If full menu cannot fit below, force it to open above.
    this.sortFilterOpenUp = spaceBelow < requiredMenuHeight;

    if (menu.classList.contains('show')) {
      setTimeout(() => {
        const dropdownApi = (window as any)?.bootstrap?.Dropdown;
        const instance = dropdownApi?.getOrCreateInstance?.(toggle);
        instance?.update?.();
      }, 0);
    }
  }

  private getSortFilterMenuHeight(menu: HTMLElement): number {
    const wasHidden = !menu.classList.contains('show');
    if (wasHidden) {
      menu.classList.add('sf-menu-measure');
    }

    const contentHeight = menu.scrollHeight || menu.getBoundingClientRect().height || 0;

    if (wasHidden) {
      menu.classList.remove('sf-menu-measure');
    }

    const viewportLimitedHeight = Math.max(220, window.innerHeight - 120);
    return Math.min(contentHeight, 550, viewportLimitedHeight);
  }

  private updateMobileMode() {
    this.mobile = window.innerWidth < 768;
  }


  logInfo(e) {
    const id = e.currentTarget.id.split("_");
    const el = document.getElementById("collapse_" + id[1]);
    el.classList.toggle("show");

    const up = document.getElementById("up_" + id[1]);
    up.classList.toggle("cla1");
    up.classList.toggle("cla2");

    const dwn = document.getElementById("dwn_" + id[1]);
    dwn.classList.toggle("cla2");
    dwn.classList.toggle("cla1");
  }

  ngAfterViewInit() {
    const elementsList: NodeListOf<Element> = document.querySelectorAll(".carat");
    elementsList.forEach((i) => {
      document.getElementById(i.id).addEventListener("click", this.logInfo.bind(this));
      i.nextElementSibling?.addEventListener("click", this.logInfo.bind(this));
    });

    const elementList: NodeListOf<Element> = document.querySelectorAll("#accordion");
    var headings = elementList[0]?.querySelectorAll('[id^="caratId"]');
    for (let i = 0; i < headings.length; i++) {
      (headings[i] as any).onclick = this.logInfo;
    }
  }

  onPrevious() {
    this.router.navigateByUrl('api/prov/atglance?entityId=' + this.apiService.getEntityId());
  }

  checkCells() {
    const wrapper = this.wrapperRef.nativeElement;
    const leftCells: NodeListOf<HTMLElement> = wrapper.querySelectorAll('.datatable-row-left .datatable-body-cell, .datatable-header-left .datatable-header-cell');
    const centerCells: NodeListOf<HTMLElement> = wrapper.querySelectorAll('.datatable-row-center .datatable-body-cell');
    const headerCells: NodeListOf<HTMLElement> = wrapper.querySelectorAll('.datatable-header .datatable-header-cell');
    const frozenCols = 2; // Set this to the number of frozen columns you have
    const centerHeaderCells = Array.from(headerCells).slice(frozenCols);

    const leftHeaderCell = headerCells[frozenCols - 0];
    const leftHeaderRight = leftHeaderCell.getBoundingClientRect().right;

    // Calculate the right edge of all left-frozen columns
    let leftFrozenRight = 0;
    leftCells.forEach((cell: HTMLElement) => {
      const rect = cell.getBoundingClientRect();
      if (rect.right > leftFrozenRight) {
        leftFrozenRight = rect.right;
      }
    });

    // Handle data cells
    centerCells.forEach((cell: HTMLElement) => {
      const cellRect = cell.getBoundingClientRect();
      if (cellRect.left < leftFrozenRight) {
        this.renderer.addClass(cell, 'covered-by-frozen');
      } else {
        this.renderer.removeClass(cell, 'covered-by-frozen');
      }
    });

    // Handle header cells
    centerHeaderCells.forEach((cell: HTMLElement) => {
      const cellRect = cell.getBoundingClientRect();
      if (cellRect.left < leftHeaderRight) {
        this.renderer.addClass(cell, 'covered-by-frozen');
      } else {
        this.renderer.removeClass(cell, 'covered-by-frozen');
      }
    });
  }

  addAnotherMember() {
    this.router.navigate(['/api/prov/member-search/'], { queryParams: { type: 'VAD' } });
  }

  removeRecord(row) {
    const payload = {
      "individualId": row.indivId,
      "userId": sessionStorage.getItem('userName'),
      "addOrRemove": "1"
    }
    this.modal.removeAddedRecord().subscribe(resp => {
      if (resp) {
        this.application.addMembers(payload, 'TCVAD', this.encodedEntityId).subscribe((res: any) => {
          if (res && res.code === '0') {
            this.totalResults.forEach((element, i) => {
              if (element.indivId === row.indivId) {
                this.totalResults.splice(i, 1)
              }
            })
            const sessionIndivArray = JSON.parse(sessionStorage.getItem('indivIdList'))
            sessionIndivArray.forEach((element, i) => {
              if (element === String(row.indivId)) {
                sessionIndivArray.splice(i, 1);
                sessionStorage.setItem('indivIdList', JSON.stringify(sessionIndivArray))
              }
            })
            if (this.totalResults.length > 0) {
              this.loadData()
            } else {
              sessionStorage.removeItem('indivIdList')
              this.addAnotherMember()
            }

          }
        })
      }
    });
  }

  toTenncare(element, action) {
    let payLoad = {}
    for (let item = 0; item < this.exportData.length; item++) {
      if (this.exportData[item]['clientId'] === element.indivId) {

        payLoad = {
          "caseNumber": this.exportData[item]['caseNumber'],
          "indvId": this.exportData[item]['clientId'],
          "actionType": action,
          "userId": sessionStorage.getItem('userName'),
          "effBegDt": this.exportData[item]['effectiveBeginDate'],
          "effEndDt": this.exportData[item]['effectiveEndDate'],
          "vclTypeCd": this.exportData[item]['vclTypeCd']
        };
        const contentHeader = new HttpHeaders({ "Content-Type": "application/json", pageId: "TCVAD", 'sessionId': this.token.getSessionId() });

        this.apiService.post(`indi/memberAssistance/updateLastAction`, payLoad, { headers: contentHeader, observe: 'response' }).subscribe((response: any) => {
          if (response?.body.code === '0') {
            sessionStorage.setItem("individualId", element.indivId);
            sessionStorage.setItem('userType', 'RP');
            sessionStorage.setItem('ViewTCC', 'true');
            gtag('event', 'actionNeededClick', {
              'event_category': 'Member Assistance Dashboard',
              'event_label': 'Clicked action needed',
              'value': action,
              'value_id': element.indivId
            })
            if (action === 'AI') {
              this.router.navigate(['user-profile/my-documents', 'documents-we-need']);
            } else {
              this.router.navigateByUrl("user-profile/benefit-dashboard");
            }

          }

        });
        break;
      };
    }

  }


  toTenncareMyLetters(element) {
    sessionStorage.setItem('individualId', element.indivId);
    sessionStorage.setItem('userType', 'RP');
    sessionStorage.setItem('ViewTCC', 'true');
    gtag('event', 'latestNoticeClick', {
      'event_category': 'Member Assistance Dashboard',
      'event_label': 'Clicked latest notice',
      'value': element.latestNotice,
      'value_id': element.indivId,
    })
    this.router.navigateByUrl("user-profile/letters/my-letters");
  }


}